/* Core & libraries */
import React, { Suspense, useEffect, useState } from 'react';
import { useTheme } from 'react-jss';
import { FormattedMessage } from 'react-intl';

/* Helpers, constants, custom methods, internal libraries */
import { useLocaleContext } from "../../contexts/localeContext";
import { useAnalytics } from "../../hooks/useAnalytics";
import { AIRLINES, PAGE_TITLES } from '../../constants/appConstants';
import { getFullLanguageText } from '../../helpers/general';
import { lazyWithPreload } from '../../helpers/lazyLoadingHelpers';
import { useFormatLocale } from '../../hooks/useFormatLocale';

/* Components */
import LogoSwitcher from "../../components/logoSwitcher";
import SpinnerBasic from '../../components/spinners/SpinnerBasic';
const CountryLanguageModalLazy = lazyWithPreload(() => import('../../components/modals/countryLanguageModal'));
import FlagIconComponent from '../../components/flagIconComponent';
import { useUserContext } from '../../contexts/userContext';
import { ReactComponent as ACLogo } from '../../resources/images/ac-landing-logo.svg';

/* Styles */
import styles from './styles.js';
import generalStyles from '../../resources/styles/general';


const LeaveCompany = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const general = generalStyles({ theme });
  const userContext = useUserContext();

  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const locale = useLocaleContext();
  const { locales } = useFormatLocale();
  const providerCode = userContext?.userInfo?.providerInfo?.providerCode;

  const { initAnalytics } = useAnalytics();

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["leaveCompany"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  return (
    <div className={`${general.main} ${classes.leaveCompanyPage}`}>
      <div className={`${general.main} ${classes.lang}`}>
        <div
          tabIndex="0"
          onClick={() => setShowLanguageModal(true)}
          className={classes.overlayLink}
          data-testid={'langselector'}
        >
          <FlagIconComponent locale={locale} flagClassName={classes.flagStyle}/>
          <div className={classes.locale}>{getFullLanguageText(locale)}</div>
        </div>
      </div>
      {providerCode === AIRLINES.AC ? <ACLogo /> : <LogoSwitcher className={providerCode === AIRLINES.AM ? classes.amLogoOverride : undefined} />}

      <div className={classes.leaveContainer}>
        <h1 className={classes.title}>
          <FormattedMessage id="leavecompany.title" />
        </h1>
        <p className={classes.description}>
          <FormattedMessage id="leavecompany.description1" />
        </p>
      </div>
      <Suspense fallback={showLanguageModal ? <SpinnerBasic /> : null}>
        {showLanguageModal && (
          <CountryLanguageModalLazy showModal={showLanguageModal} setShowModal={setShowLanguageModal} locales={locales}/>
        )}
      </Suspense>
    </div>
  );
};

export default LeaveCompany;
